import LexicalEditor from '../../../../general/LexicalEditor';

interface PdfNotesEditorProps {
  title: string;
  description: string;
  // The saved note. The editor only reloads when this changes, so pass the saved value, not the
  // draft being typed.
  savedNotes: string;
  onChange: (html: string) => void;
  disabled?: boolean;
}

// Rich-text note printed in the notes box on a PDF. Stored as the editor's HTML; the PDF keeps
// only basic formatting (bold, italic, underline, strikethrough, lists) - see dill-shared pdfNotes.
export const PdfNotesEditor = ({
  title,
  description,
  savedNotes,
  onChange,
  disabled = false,
}: PdfNotesEditorProps) => (
  <div>
    <p className="text-xs font-medium text-gray-800">{title}</p>
    <p className="text-[11px] text-gray-400 mt-0.5 mb-3">{description}</p>
    <LexicalEditor
      initialContent={savedNotes}
      onChange={onChange}
      outputFormat="html"
      editable={!disabled}
      autoFocus={false}
      minHeight="110px"
      placeholder="Add a note..."
    />
  </div>
);
